import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div dir="rtl" style={{ padding: '40px', textAlign: 'center', fontFamily: 'Heebo, sans-serif' }}>
          <h1 style={{ color: '#C4956A', marginBottom: '20px' }}>אופס! משהו השתבש</h1>
          <p style={{ color: '#666', marginBottom: '20px' }}>אנא רעננו את הדף או נסו שוב מאוחר יותר</p>
          <button 
            onClick={() => window.location.reload()} 
            style={{ 
              background: '#C4956A', 
              color: 'white', 
              padding: '12px 24px', 
              border: 'none', 
              borderRadius: '25px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            רענן את הדף
          </button>
          <p style={{ color: '#999', marginTop: '20px', fontSize: '12px' }}>
            {this.state.error?.message}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
